module.exports = __webpack_public_path__ + "9f170c81584ade960ab924d1428ecd5f.png";